import { z } from "zod";

const configurationAuditRoutingKeys = [
	"Created",
	"Updated",
	"Restored",
	"Deleted",
	"Machine.Updated",
	"Machine.Created",
	"Machine.Deleted",
	"Machine.TracksChanged",
] as const;
export const configurationAuditRoutingKeySchema = z
	.string()
	.refine((val) => configurationAuditRoutingKeys.some((key) => val.includes(key)), {
		message: "String does not contain any valid routing key",
	});

const configurationAuditTypes = [
	"ProductionGroup",
	"MachineGroup",
	"PickZone",
	"CartonPropertyGroup",
	"Corrugate",
	"PrintTemplate",
	"CVPRange",
	"LantechCaseSealer",
	"Em",
	"Fusion",
	"PL1",
	"SealProX",
	"X4",
	"X5",
	"X6",
	"X7",
	"Zebra",
] as const;
export const configurationAuditTypeSchema = z.enum(configurationAuditTypes);

export const configurationAuditEntrySchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	entityId: z.string(),
	createDateUTC: z.string(),
	routingKey: configurationAuditRoutingKeySchema,
	auditType: configurationAuditTypeSchema,
	userId: z.string(),
	data: z.string(),
});

export const configurationAuditHistorySchema = z.array(configurationAuditEntrySchema);

export type ConfigurationAuditType = z.infer<typeof configurationAuditTypeSchema>;
export type ConfigurationAuditEntry = z.infer<typeof configurationAuditEntrySchema>;
export type ConfigurationAuditHistory = z.infer<typeof configurationAuditHistorySchema>;
export type ConfigurationAuditRoutingKey = z.infer<typeof configurationAuditRoutingKeySchema>;
